import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFAQs } from '../../services/FAQApi';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  data: {},
};

export const fetchFAQs = createAsyncThunk('FETCH_FAQS', getFAQs);
export const faqSlice = createSlice({
  name: 'faqs',
  initialState,
  reducers: {
    resetFAQsList: (state) => {
      state.loading = false;
      state.data = {};
    },
  },
  extraReducers: {
    [fetchFAQs.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchFAQs.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [fetchFAQs.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { resetFAQsList } = faqSlice.actions;

const { reducer } = faqSlice;

export default reducer;
